//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FCImage from '~/components/FCImage.vue';

export default {
  name: 'Founders',
  components: {
    FCImage,
  },
  computed: {
    founders() {
      return [
        {
          name: 'Khalil Zahar',
          title: 'Chief Executive Officer',
          src: 'v4/fc-about-us-khalil-headshot-001.png',
          alt: 'Khalil Zahar headshot',
        },
        {
          name: 'Patrick Chandler',
          title: 'Chief Marketing Officer',
          src: 'v4/fc-about-us-patrick-headshot-001.png',
          alt: 'Patrick Chandler headshot',
        },
        {
          name: 'Tommy Duquette',
          title: 'Chief Content Officer',
          src: 'v4/fc-about-us-tommy-headshot-001.png',
          alt: 'Tommy Duquete headshot',
        },
        {
          name: 'Alexandre Lapointe',
          title: 'VP of Engineering',
          src: 'v4/fc-about-us-turbo-headshot-001.png',
          alt: 'Turbo headshot',
        },
        {
          name: 'Alexandre Marcotte',
          title: 'Chief Technical Officer',
          src: 'v4/fc-about-us-alex-headshot-001.png',
          alt: 'Alexandre Marcotte headshot',
        },
        {
          name: 'Jerome Rousseau',
          title: 'Chief Operating Officer',
          src: 'v4/fc-about-us-jay-headshot-001.png',
          alt: 'Jerome Rousseau headshot',
        },
      ];
    },
  },
};
